// @flow

/**
 * An enumeration of the different virtual background types.
 *
 * @enum {string}
 */
export const VIRTUAL_BACKGROUND_TYPE = {
    IMAGE: 'image',
    DESKTOP_SHARE: 'desktop-share',
    VIDEO: 'video',
    BLUR: 'blur',
    NONE: 'none'
};


export type Image = {
    tooltip?: string,
    id: string,
    src: string
}

// The limit of virtual background uploads is 24. When the number
// of uploads is 25 we trigger the deleteStoredImage function to delete
// the first/oldest uploaded background.
export const BACKGROUNDS_LIMIT = 75;


export const IMAGES: Array<Image> = [
    {
        tooltip: 'image1',
        id: '1',
        type: 'image',
        src: 'images/virtual-background/background-1.jpg'
    },
    {
        tooltip: 'image2',
        id: '2',
        type: 'image',
        src: 'images/virtual-background/background-2.jpg'
    },
    {
        tooltip: 'image3',
        id: '3',
        type: 'image',
        src: 'images/virtual-background/background-3.jpg'
    },
    {
        tooltip: 'image4',
        id: '4',
        type: 'image',
        src: 'images/virtual-background/background-4.jpg'
    },
    {
        tooltip: 'image5',
        id: '5',
        type: 'image',
        src: 'images/virtual-background/background-5.jpg'
    },
    {
        tooltip: 'image6',
        id: '6',
        type: 'image',
        src: 'images/virtual-background/background-6.jpg'
    },
    {
        tooltip: 'image7',
        id: '7',
        type: 'image',
        src: 'images/virtual-background/background-7.jpg'
    },
    {   tooltip: 'image8',
        id: '8',
        type: 'image',
        src: 'images/virtual-background/background-8.jpg'
    },
    {   
        tooltip: 'image9',
        id: '9',
        type: 'image',
        src: 'images/virtual-background/background-9.jpg'
    },
    {
        tooltip: 'image10',
        id: '10',
        type: 'image',
        src: 'images/virtual-background/background-10.jpg'
    },
    {
        tooltip: 'image11',
        id: '11',
        type: 'image',
        src: 'images/virtual-background/background-11.jpg'
    },
    {
        tooltip: 'image12',
        id: '12',
        src: 'images/virtual-background/background-12.jpg'
    },
    {
        tooltip: 'image13',
        id: '13',
        type: 'image',
        src: 'images/virtual-background/background-13.jpg'
    },
    {
        tooltip: 'image14',
        id: '14',
        type: 'image',
        src: 'images/virtual-background/background-14.png'
    },
    {
        tooltip: 'image15',
        id: '15',
        type: 'image',
        src: 'images/virtual-background/background-15.jpeg'
    },
    {
        tooltip: 'image16',
        id: '16',
        type: 'image',
        src: 'images/virtual-background/background-16.jpeg'
    },
    {
        tooltip: 'image17',
        id: '17',
        type: 'image',
        src: 'images/virtual-background/background-17.jpeg'
    },
    {
        tooltip: 'image18',
        id: '18',
        type: 'image',
        src: 'images/virtual-background/background-18.jpeg'
    },
    {
        tooltip: 'image19',
        id: '19',
        type: 'image',
        src: 'images/virtual-background/background-19.jpeg'
    },
    {
        tooltip: 'image20',
        id: '20',
        type: 'image',
        src: 'images/virtual-background/background-20.jpg'
    },
    {
        tooltip: 'image21',
        id: '21',
        src: 'images/virtual-background/background-21.jpg'
    },
    {
        tooltip: 'image22',
        id: '22',
        type: 'image',
        src: 'images/virtual-background/background-22.jpg'
    },
    {
        tooltip: 'image23',
        id: '23',
        src: 'images/virtual-background/background-23.jpg'
    },
    {
        tooltip: 'image24',
        id: '24',
        type: 'image',
        src: 'images/virtual-background/background-24.jpg'
    },
    {
        tooltip: 'image25',
        id: '25',
        src: 'images/virtual-background/background-25.jpg'
    },
    {
        tooltip: 'image26',
        id: '26',
        type: 'image',
        src: 'images/virtual-background/background-26.jpg'
    },
    {
        tooltip: 'image27',
        id: '27',
        type: 'image',
        src: 'images/virtual-background/background-27.jpg'
    },
    {
        tooltip: 'image28',
        id: '28',
        type: 'image',
        src: 'images/virtual-background/background-28.jpg'
    },
    {
        tooltip: 'image29',
        id: '29',
        type: 'image',
        src: 'images/virtual-background/background-29.jpg'
    },
    {
        tooltip: 'image30',
        id: '30',
        type: 'image',
        src: 'images/virtual-background/background-30.jpg'
    },
    {
        tooltip: 'image31',
        id: '31',
        type: 'image',
        src: 'images/virtual-background/background-31.jpg'
    },
    {
        tooltip: 'image32',
        id: '32',
        type: 'video',
        src: 'images/virtual-background/background-32.png',
        file: 'images/virtual-background/background-32.mp4'
    },
    {
        tooltip: 'image33',
        id: '33',
        type: 'video',
        src: 'images/virtual-background/background-33.png',
        file: 'images/virtual-background/background-33.mp4'
    },
    {
        tooltip: 'image34',
        id: '34',
        type: 'video',
        src: 'images/virtual-background/background-34.png',
        file: 'images/virtual-background/background-34.mp4'
    },
    {
        tooltip: 'image35',
        id: '35',
        type: 'video',
        src: 'images/virtual-background/background-35.jpg',
        file: 'images/virtual-background/background-35.mp4'
    },
    {
        tooltip: 'image36',
        id: '36',
        type: 'video',
        src: 'images/virtual-background/background-36.jpg',
        file: 'images/virtual-background/background-36.mp4'
    },
    {
        tooltip: 'image37',
        id: '37',
        type: 'video',
        src: 'images/virtual-background/background-37.jpg',
        file: 'images/virtual-background/background-37.mp4'
    },
    {
        tooltip: 'image38',
        id: '38',
        type: 'video',
        src: 'images/virtual-background/background-38.jpg',
        file: 'images/virtual-background/background-38.mp4'
    },
    {
        tooltip: 'image39',
        id: '39',
        type: 'video',
        src: 'images/virtual-background/background-39.jpg',
        file: 'images/virtual-background/background-39.mp4'
    },
    {
        tooltip: 'image40',
        id: '40',
        type: 'video',
        src: 'images/virtual-background/background-40.png',
        file: 'images/virtual-background/background-40.mp4'
    },
    {
        tooltip: 'image41',
        id: '41',
        type: 'video',
        src: 'images/virtual-background/background-41.png',
        file: 'images/virtual-background/background-41.mp4'
    },
    {
        tooltip: 'image42',
        id: '42',
        type: 'video',
        src: 'images/virtual-background/background-42.png',
        file: 'images/virtual-background/background-42.mp4'
    }
];
